import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import RemoveISTSubtemplateEditing from './removeistsubtemplateediting';

export default class RemoveISTSubtemplate extends Plugin {
  static get pluginName() {
    return "RemoveISTSubtemplate";
  }

  static get requires() {
    return [RemoveISTSubtemplateEditing];
  }
}